import { PropsWithChildren } from 'react';

import { RuleVersionActionsContextProvider } from './RuleVersionActionsProvider.context';
import { useRuleVersionActions } from './RuleVersionActionsProvider.hook';

interface RuleVersionActionsProviderProps {
  id: string;
}

export const RuleVersionActionsProvider = ({ id, children }: PropsWithChildren<RuleVersionActionsProviderProps>) => {
  const props = useRuleVersionActions({ id });

  return <RuleVersionActionsContextProvider value={props}>{children}</RuleVersionActionsContextProvider>;
};
